import ComponentManager from '@/Management/ComponentManager';
import HeaderViewFactory from '@/Factories/ViewFactories/HeaderViewFactory';
import ReducedHeaderView from '@/Components/ReducedHeader/ReducedHeaderView';
import ReducedHeaderViewModel from '@/Components/ReducedHeader/ReducedHeaderViewModel';

export default class ReducedHeaderViewFactory extends HeaderViewFactory {

    constructor(params: any) {
        super(params);
    }

    /**
     * @override
     * @param viewModel
     */
    public createView(viewModel: ReducedHeaderViewModel): ReducedHeaderView {
        const headerView = ComponentManager.getView<typeof ReducedHeaderView>('ReducedHeader');
        return new headerView(viewModel, this.createRootElement('Header'));
    }

    /**
     * @override
     */
    public createViewModel(): ReducedHeaderViewModel {
        const headerViewModel = ComponentManager.getViewModel<typeof ReducedHeaderViewModel>('ReducedHeader');

        return new headerViewModel(this.createViewModelParameter());
    }
}

ComponentManager.setFactory('ReducedHeader', ReducedHeaderViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');